/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { Unavailability } from './Unavailability';
import {
    UnavailabilityFromJSON,
    UnavailabilityFromJSONTyped,
    UnavailabilityToJSON,
    UnavailabilityToJSONTyped,
} from './Unavailability';

/**
 * 
 * @export
 * @interface ListUnavailabilityResponse
 */
export interface ListUnavailabilityResponse {
    /**
     * 
     * @type {Array<Unavailability>}
     * @memberof ListUnavailabilityResponse
     */
    data: Array<Unavailability>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListUnavailabilityResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListUnavailabilityResponse interface.
 */
export function instanceOfListUnavailabilityResponse(value: object): value is ListUnavailabilityResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListUnavailabilityResponseFromJSON(json: any): ListUnavailabilityResponse {
    return ListUnavailabilityResponseFromJSONTyped(json, false);
}

export function ListUnavailabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListUnavailabilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(UnavailabilityFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListUnavailabilityResponseToJSON(json: any): ListUnavailabilityResponse {
      return ListUnavailabilityResponseToJSONTyped(json, false);
  }

  export function ListUnavailabilityResponseToJSONTyped(value?: ListUnavailabilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(UnavailabilityToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

